// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1SuHx","clinicsSelect":"TableHeading_clinicsSelect__1cOQ6"};